/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import EditInputHeader from 'app/components/Headers/EditInputHeader.jsx';
import FeedEditorTabs from 'app/components/EditorComponents/FeedEditorTabs.jsx';
import InputLogPanel from 'app/components/EditorComponents/InputLogPanel.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import * as _ from 'underscore';
import Loading from 'app/components/common/Loading.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class CurateLogView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            inputId: this.props.router.params.inputId,
            input: {}
        };

        if (props.curation.route.id !== undefined) {
            props.getCurations(props.curation.route.id);
        }

    }

    static getDerivedStateFromProps(props, state) {

        if (!_.isEmpty(props.curation.route)) {
            for (let i = 0; i < props.curation.route.inputs.length; ++i) {
                if (props.curation.route.inputs[i].id == state.inputId) {
                    if (!_.isEqual(props.curation.route.inputs[i], state.input)) {
                        return {
                            input: props.curation.route.inputs[i]
                        };
                    }
                }
            }
        }

        return null;

    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.curation.loaded && (_.isEmpty(prevProps.curation.route) && !_.isEmpty(this.props.curation.route))) {
            this.props.getCurationInputLog(this.state.inputId);
        }

    }

    render() {
        let header = null,
            main = null,
            inputLabel = '';


        if (_.isEmpty(this.state.input)) {
            main = (
                <Loading/>
            );
        } else {
            inputLabel = ConstantMixin.getInputServiceByCode(this.state.input.type);
    		if (inputLabel !== 'Feed') {
    			inputLabel += " Feed";
    		}

            header = (
                <EditInputHeader
                    {...this.props}
                    action={this.state.input.name}
                    routeViewType={2}
                    section={"Curated Feeds"}
                    statusOnly={true} />
            );

            main = (
                <div>
                    <FeedEditorTabs
                        {...this.props}
                        inputType={this.state.input.type}
                        feedLabel={inputLabel}
                        showSocial={false} />
                    <InputLogPanel
                        {...this.props}
                        log={this.state.input.log} />
                </div>
            );
        }

        return (
            <Content header={header} main={main} />
        );
    }

};

CurateLogView.displayName = "CurateLogView";

export default ComponentWithContext(CurateLogView);
